// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.quality-statistics-header {
  display: grid;
  gap: 12px;
  padding: 12px 8px;
}

.quality-statistics-title {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  color: var(--ion-text-color);
  font-size: 18px;
  font-weight: 700;
  line-height: 1.25;
}

.quality-statistics-title ion-icon {
  flex: 0 0 auto;
  font-size: 18px;
}

.quality-statistics-title span {
  min-width: 0;
  overflow-wrap: anywhere;
}

.quality-statistics-filters {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  width: 100%;
}

.quality-statistics-date,
.quality-statistics-action {
  min-width: 0;
  width: 100%;
}

.quality-statistics-action ion-button {
  margin: 0;
}

ion-card {
  border-radius: 12px;
}

ion-list {
  padding: 0;
}

ion-item {
  --padding-start: 12px;
  --inner-padding-end: 12px;
}

@media (min-width: 640px) {
  .quality-statistics-header {
    padding: 12px;
  }
  .quality-statistics-filters {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) auto;
    align-items: center;
  }
}
@media (min-width: 1024px) {
  .quality-statistics-header {
    grid-template-columns: minmax(260px, auto) minmax(0, 1fr);
    align-items: center;
  }
  .quality-statistics-filters {
    justify-self: end;
    max-width: 720px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/_components/qualita/qualita-statistics/qualita-statistics.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,4BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;AACF;;AAEA;EACE,YAAA;EACA,uBAAA;AACF;;AAEA;EACE,aAAA;EACA,0BAAA;EACA,QAAA;EACA,WAAA;AACF;;AAEA;;EAEE,YAAA;EACA,WAAA;AACF;;AAEA;EACE,SAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,qBAAA;EACA,yBAAA;AACF;;AAEA;EACE;IACE,aAAA;EACF;EAEA;IACE,yDAAA;IACA,mBAAA;EAAF;AACF;AAGA;EACE;IACE,yDAAA;IACA,mBAAA;EADF;EAIA;IACE,iBAAA;IACA,gBAAA;EAFF;AACF","sourcesContent":[":host {\n  display: block;\n}\n\n.quality-statistics-header {\n  display: grid;\n  gap: 12px;\n  padding: 12px 8px;\n}\n\n.quality-statistics-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  color: var(--ion-text-color);\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 1.25;\n}\n\n.quality-statistics-title ion-icon {\n  flex: 0 0 auto;\n  font-size: 18px;\n}\n\n.quality-statistics-title span {\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n.quality-statistics-filters {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 8px;\n  width: 100%;\n}\n\n.quality-statistics-date,\n.quality-statistics-action {\n  min-width: 0;\n  width: 100%;\n}\n\n.quality-statistics-action ion-button {\n  margin: 0;\n}\n\nion-card {\n  border-radius: 12px;\n}\n\nion-list {\n  padding: 0;\n}\n\nion-item {\n  --padding-start: 12px;\n  --inner-padding-end: 12px;\n}\n\n@media (min-width: 640px) {\n  .quality-statistics-header {\n    padding: 12px;\n  }\n\n  .quality-statistics-filters {\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) auto;\n    align-items: center;\n  }\n}\n\n@media (min-width: 1024px) {\n  .quality-statistics-header {\n    grid-template-columns: minmax(260px, auto) minmax(0, 1fr);\n    align-items: center;\n  }\n\n  .quality-statistics-filters {\n    justify-self: end;\n    max-width: 720px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
